export default __webpack_public_path__ + "66a135acfdd6d36723babfe302ab9a20.glb";